import * as d3 from "d3";
import React, { useEffect, useState } from "react";
import covid from "../../data/us-cases.csv";
import { apDateTimeLocale } from "./utils";

const divStyle = {
  width: "100vw",
  height: "100%",
  zIndex: "-1",
};

// AP date and time using D3 time format locales
// This is eastern time as specified in the `time` definition
// Change accordingly

const Graphic = ({ x, scrollAmount }) => {
  const [data, setData] = useState();

  useEffect(() => {
    d3.csv(covid).then((data) => {
      data.forEach((v) => {
        v.cases = +v.cases;
        v.deaths = +v.deaths;
        v.date = new Date(v.date);
        v.date.setHours(0, 0, 0, 0);
      });
      setData(data);
    });
  }, []);

  // set up an x scale
  const [start, end] = [
    x.domain()[0],
    // x.invert(-1 * scrollAmount),
    d3.max([
      new Date("2020/3/16"),
      x.invert(-1 * scrollAmount + window.innerWidth),
    ]),
  ];

  const xScale = d3
    .scaleBand()
    .domain(d3.timeDay.range(start, end))
    .range([0, window.innerWidth])
    .padding(0.1);
  const filtered = data
    ? data.filter((d) => d.date > start && d.date < end)
    : [];

  const last = filtered.length ? filtered.slice(-1)[0] : null;

  const yScale = d3
    .scaleLinear()
    .domain(data ? d3.extent(filtered.map((d) => d.deaths)) : [0, 1])
    .range([0, 0.9 * window.innerHeight]);
  // .nice();
  const date = xScale.domain().slice(-1)[0];
  const dateFmt = apDateTimeLocale.format("%b %e, %Y");
  if (!last) {
    return <div></div>;
  }

  // draw the graph
  return (
    <div style={divStyle} className="chart">
      <div
        style={{
          position: "absolute",
          left: xScale(last?.date || date) + xScale.bandwidth() / 2,
          width: "fit-content",
          textAlign: "right",
          transform: "translate(-100%)",
          top: "5vh",
        }}
      >
        By <b>{dateFmt(last?.date)}</b>,{" "}
        <span className="deaths">
          <b>{d3.format(",")(last?.deaths)}</b>
        </span>{" "}
        people had died of COVID-19 in the U.S.
      </div>
      <svg>
        {filtered.map((d) => {
          return (
            <rect
              x={xScale(d.date)}
              y={window.innerHeight - yScale(d.deaths)}
              width={xScale.bandwidth()}
              height={yScale(d.deaths)}
              className="bar"
              key={d.date}
            ></rect>
          );
        })}
      </svg>
    </div>
  );
};

export default Graphic;
